// extracted by mini-css-extract-plugin
module.exports = {"heading":"bubbleHeading_heading__1H6b3","subheading":"bubbleHeading_subheading__1RIre"};